/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GeoPoint } from './GeoPoint';
import {
    GeoPointFromJSON,
    GeoPointFromJSONTyped,
    GeoPointToJSON,
    GeoPointToJSONTyped,
} from './GeoPoint';

/**
 * 
 * @export
 * @interface Town
 */
export interface Town {
    /**
     * 
     * @type {string}
     * @memberof Town
     */
    name?: string;
    /**
     * 
     * @type {GeoPoint}
     * @memberof Town
     */
    geo?: GeoPoint;
    /**
     * 
     * @type {number}
     * @memberof Town
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Town
     */
    parishId?: number;
    /**
     * 
     * @type {number}
     * @memberof Town
     */
    courierId?: number;
}

/**
 * Check if a given object implements the Town interface.
 */
export function instanceOfTown(value: object): value is Town {
    return true;
}

export function TownFromJSON(json: any): Town {
    return TownFromJSONTyped(json, false);
}

export function TownFromJSONTyped(json: any, ignoreDiscriminator: boolean): Town {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'geo': json['geo'] == null ? undefined : GeoPointFromJSON(json['geo']),
        'id': json['id'] == null ? undefined : json['id'],
        'parishId': json['parishId'] == null ? undefined : json['parishId'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function TownToJSON(json: any): Town {
    return TownToJSONTyped(json, false);
}

export function TownToJSONTyped(value?: Town | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'geo': GeoPointToJSON(value['geo']),
        'id': value['id'],
        'parishId': value['parishId'],
        'courierId': value['courierId'],
    };
}

